<template>
  <transition-group tag="div" class="notifications" name="slide-fade">
    <SfNotification v-for="notification in notifications" :key="notification.id" :message="notification.message"
      :action="notification.action && notification.action.text" :type="notification.type"
      :class="notification.class"
      @click:action="notification.action && notification.action.onClick()" visible>
      <template #message>
        <div>
          <div v-if="notification.message" class="notificationMessage">{{ notification.message }}</div>
          <div v-else-if="notification.image">
            <img :src="notification.image" alt="notification image" style="width:100%;" />
          </div>
        </div>
      </template>
      <template #icon v-if="notification.icon">
        <SfIcon :icon="notification.icon" color="white" />
      </template>
      <template v-slot:action="{ action, actionHandler }">
        <sf-button
          :style="{ marginTop: notification.action.type === 'primary'?'1rem':'', width: notification.action.type === 'primary'?'100%':'' }"
          :class="{ 'display-none': !action, 'sf-button--pure': notification.action.type !== 'primary', 'sf-notification__action': notification.action.type !== 'primary' }"
          @click="actionHandler()"
        >
          {{ action }}
        </sf-button>
      </template>
      <template #close>
        <Sf-button
          :class="{ 'display-none': notification.persistent }"
          :aria-label="'Close notification'"
          class="sf-button--pure sf-notification__close"
          @click="closeNotification(notification)"
        >
          <SfIcon icon="cross" color="white" />
        </Sf-button>
      </template>
    </SfNotification>
  </transition-group>
</template>

<script>
import { SfIcon, SfButton } from '@storefront-ui/vue';
import { useUiNotification } from '~/composables';
import SfNotification from '@/components/SfNotification.vue';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'Notification',
  components: {
    SfNotification,
    SfIcon,
    SfButton
  },
  setup () {
    const { notifications } = useUiNotification();
    const closeNotification = (notification) => {
      if (!notification) return;
      notification.dismiss();
      // 判断是否是点击触发
      if (notification.paycode) {
        EventBus.$emit('paycode-close-notification', notification.id);
      }
    };
    return {
      notifications,
      closeNotification
    };
  }
};
</script>

<style scoped lang="scss">
.notifications {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999999999999999999 !important;
  @include for-desktop {
    top: 100px;
    left: auto;
    bottom: auto;
    right: 5%;
    width: 320px;
  }
}
.sf-notification {
  max-width: 100%;
  margin: var(--spacer-xs) auto 0 auto;
  &:first-child {
    margin-top: 0;
  }
  @include for-mobile {
    --notification-action-display: block;
    --notification-border-radius: 0;
    --notification-max-width: 100%;
    --notification-background: var(--c-link);
    --notification-font-size: var(--font-size--sm);
    --notification-font-family: var(--font-family--primary);
    --notification-font-weight: var(--font-weight--normal);
    --notification-padding: var(--spacer-base) var(--spacer-lg);
  }
  @include for-desktop {
    margin: 0 0 var(--spacer-xs) 0;
  }
  .notificationMessage{
    width:90%;
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s;
  @include for-desktop {
    transition: opacity 0.25s linear;
  }
}
.slide-fade-enter {
  transform: translateY(40px);
  @include for-desktop {
    opacity: 0;
  }
}
.slide-fade-leave-to {
  transform: translateY(80px);
  @include for-desktop {
    opacity: 0;
  }
}
</style>
<style lang="scss">
 .notificationImage {
   padding: var(--spacer-lg);
   .NotificationContext{
     width: 100%;
   }
   .sf-notification__icon{
    display: none;
   }
   .sf-notification__close{
    @include for-desktop {
      --notification-close-top: var(--spacer-sm);
    }
   }
 }
 .centerImage{
  right: 35vw !important;
 }
 .hideClose1 {
  .sf-notification__close{
    display: none;
  }
 }
</style>
